import { useSelector } from 'react-redux';

// eslint-disable-next-line import/prefer-default-export
export const useGetUsersOfUserSideBar = () => {
  const {
    users: { items: usersAtSelectedAreasLevel },
  } = useSelector((state) => state.taskViewPageReducer);
  return usersAtSelectedAreasLevel;
};
